import { domainUrl } from '../constants';

export const API_CUSTOMER_REVIEWS = `${domainUrl}customer/reviews`;
export const API_CUSTOMER_REVIEWS_ID = `${domainUrl}customer/reviews/{id}`;
export const API_CUSTOMER_REVIEW_PUBLISHED = `${domainUrl}customer/reviews/published`;
export const API_CUSTOMER_REVIEW_PENDING = `${domainUrl}customer/reviews/pending`;
export const API_CUSTOMER_REVIEW_LOCKED = `${domainUrl}customer/reviews/locked`;
